import { Can } from 'providers/casl'

export const onPortalAccess = (can: Can) => {
  can('access', 'PortalPage')
}
